export const rent = {
  "rent": [{
    "title": "温馨一居室出租",
    "pic": "",
    "location": "成都市锦江区",
    "public": "李先生",
    "mobile": "18030789959",
    "address": "春熙路街道恒大华府",
    "fee": "5000",
    "description": `省时——精装修、办公室配套齐全，租期灵活即租即用，拎包携笔记本即时开展业务往来
省钱——前期无大笔装修费用，入驻后免物业费、水费、电费、空调费、清洁费等
专业——IT支持，高配置的电话网络 办公便捷 效率高
灵活——各种不同类型的办公间组合，可满足1至6人的独立办公需求，价格从680至2680不等
`
  }, {
    "title": "地铁旁精装两居室",
    "pic": "",
    "location": "成都市青羊区",
    "public": "张女士",
    "mobile": "18123392356",
    "address": "青羊大道街道华阳景苑",
    "fee": "7000",
    "description": `高级办公桌、椅、柜等家具     
每日邮递签收
每日1次以上公共区域清洁    
免费定期清洁服务，前台预约                          
24小时实时监控，IC卡门禁进出安全
`
  },  {
    "title": "独立小院两层别墅",
    "pic": "",
    "location": "成都市武侯区",
    "public": "王先生",
    "mobile": "18161219551",
    "address": "科华北路街道中海名城",
    "fee": "12000",
    "description": `1、提供场所申请设立公司，可提供记账报税、等专业服务。
2、为无需上门办公客户提供企业托管服务，轻松开展核心业务。
3、提供会议室、洽谈室、休闲区、咖啡吧、书吧、大型前台等满足您的不同需求。
`
  }, {
    "title": "市中心豪华公寓",
    "pic": "",
    "location": "绵阳市涪城区",
    "public": "刘女士",
    "mobile": "18180237539",
    "address": "剑南路街道五彩城",
    "fee": "15000",
    "description": `1.房屋整体转让营业额可观
2.房屋空间大，操作性强。
3.专业商务秘书以客户前台文员身份接待会员的客户和提供会议服务。
`
  }, {
    "title": "近地铁三居室",
    "pic": "",
    "location": "成都市武侯区",
    "public": "赵先生",
    "mobile": "13738240198",
    "address": "武侯区人民南路四段120号",
    "fee": "6000",
    "description": `1、提供场所申请工商设立登记，省心省事省成本，同时提供工商设立，等专业服务。
2、为无需办公空间客户提供企业托管服务，轻松开展核心业务。
3、前台代收代转邮件、包裹；文书服务（打印、复印、传真、扫描）收发传真、电邮。
`
  }, {
    "title": "景区旁精装修公寓",
    "pic": "",
    "location": "绵阳市游仙区",
    "public": "孙女士",
    "mobile": "18180702359",
    "address": "东原大道街道美的城",
    "fee": "8000",
    "description": `1.房屋地理位置好，人流大。
2.房屋经营无压力，消费集中。
3本店消费符合周边周边人群、便于发展。
`
  }, {
    "title": "宁静小区两居室",
    "pic": "",
    "location": "乐山市市中区",
    "public": "周先生",
    "mobile": "18180847959",
    "address": "海棠路街道阳光尚城",
    "fee": "5500",
    "description": `一、无带看费用看房直接到小区，诚信出租杜绝虚假房源，不浪费彼此宝贵时间！
二、诚邀您看房除了本房还可以按需匹配，全成都都有！
三、付款方式灵活月付、季付、半年付、年付，根据你的需求决定！
四、配套完善，家电家具齐全，空调，冰箱，洗衣机，宽带，热水器应有尽有！可直接拎包入住！
五、交通便利，离地铁口，公交站近，出行方便！
`
  }, {
    "title": "新装修一居室",
    "pic": "",
    "location": "乐山市沙湾区",
    "public": "吴女士",
    "mobile": "18181497359",
    "address": "人民东路街道翡翠城",
    "fee": "4500",
    "description": `1、周边各种超市，商场应有尽有，生活设施便利！
2、可直接电话联系，随时约看房无看房费，欢迎咨询！
3、交通便利，离地铁口，公交站近，出行方便！
4、周边各种超市，商场应有尽有，生活设施便利！
5、可直接电话联系，随时约看房，欢迎咨询！
`
  }, {
    "title": "大学城旁二居室",
    "pic": "",
    "location": "自贡市自流井区",
    "public": "何先生",
    "mobile": "19157683959",
    "address": "南湖路街道新都汇",
    "fee": "5000",
    "description": `第一：该房屋位于保利星座，1室1厅1卫，户型方正，采光好，通风效果好。
第二：该房屋配有宽大舒适的床、超大的液晶电视、简洁大方的餐桌、结实耐用的衣柜、大储存量的冰箱、实用的洗衣机，同时房间均配置空调，保证冬暖夏凉，给你一个舒适的居住环境。
第三：小区环境舒适，不临主干道，安静，绿化好，干净整洁，小区安保好，物业认真负责。
`
  }, {
    "title": "繁华商圈一居室",
    "pic": "",
    "location": "自贡市贡井区",
    "public": "韩女士",
    "mobile": "18783940138",
    "address": "建设路街道金地名苑",
    "fee": "4800",
    "description": `商场：大源中央公园、伊藤洋华堂、麦德龙、家乐福、世豪广场、复城国际广场。
医院：成都市第一医院、华西口腔医院、德国巴伐利亚国际医院、宋庆龄儿童医院。
学校：成都七中、石室中学、益州小学，金苹果幼儿园，成都教科院附属学校。
银行：建行、农行、工行、民生、农商等相关银行及大型农贸市场。
`
  }, {
    "title": "近商场两居室",
    "pic": "",
    "location": "宜宾市翠屏区",
    "public": "陈先生",
    "mobile": "18781278363",
    "address": "金沙江大道街道金域蓝湾",
    "fee": "5200",
    "description": `交通：小区交通很便利，出门附近地铁口，
商圈：小区门口红旗连锁，房间干净卫生，房间保证采光。
家电：空调，洗衣机，微波炉，等家具家电齐全。当天就可以直接拎包入住安全：全密码锁，
小区：小区24TH门禁，方便进出。夜班也不用担心开门，电梯公寓，绿化面积大，小区环境优良。
优惠：诚心出租，客户价格可谈。详情来电咨询。
`
  }, {
    "title": "江景房豪华三居室",
    "pic": "",
    "location": "成都市武侯区",
    "public": "杨女士",
    "mobile": "18381973926",
    "address": "玉林街道华西美庐小区",
    "fee": "10000",
    "description": `1.交通便利,照片都是实景拍摄，绝无虚假
2.随时免费带你看房，留言或者电话联系
3.付款方式灵活，可以押一付一，押一付三
4.全成都都有房源，房源都是跟房东本人签合同
5.我们是中介签约成功收取半个月租金作为
`
  }]
}